import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ff8af06a-976d-4efd-824f-28da774a6e41/artifacts/2h81g2hn_use%20pc%20hindi%20logo.png";

const Footer = () => {
  return (
    <footer className="footer-main" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Info */}
          <div className="lg:col-span-1">
            <img 
              src={LOGO_URL} 
              alt="Punjabi Chaska" 
              className="h-24 w-auto mb-6 object-contain"
              data-testid="footer-logo"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Bringing the authentic taste of premium Hing (Asafoetida) to Indian kitchens. 
              Quality you can trust, flavor you'll love.
            </p>
            <div className="quality-badge">
              100% Pure & Natural
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="footer-link" data-testid="footer-link-home">Home</Link>
              </li>
              <li>
                <Link to="/about" className="footer-link" data-testid="footer-link-about">About Us</Link>
              </li>
              <li>
                <Link to="/products" className="footer-link" data-testid="footer-link-products">Our Products</Link>
              </li>
              <li>
                <Link to="/quality" className="footer-link" data-testid="footer-link-quality">Quality Assurance</Link>
              </li>
              <li>
                <Link to="/legal" className="footer-link" data-testid="footer-link-legal">GST & Legal</Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link" data-testid="footer-link-contact">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-orange-500 mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  Basement, Bhukand No.-7, Transport Nagar,<br />
                  Bulandshahr, Uttar Pradesh - 203001
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-orange-500 flex-shrink-0" />
                <a href="tel:+919758308200" className="footer-link" data-testid="footer-phone">
                  +91 9758308200
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-orange-500 flex-shrink-0" />
                <a href="mailto:shrivishnuudhyog@gmail.com" className="footer-link" data-testid="footer-email">
                  shrivishnuudhyog@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Legal Information</h3>
            <div className="bg-gray-800 rounded-lg p-4">
              <p className="text-gray-400 text-xs mb-2">Registered Company</p>
              <p className="text-white text-sm font-medium mb-3">
                Shri Vishnu Udhyog
              </p>
              <p className="text-gray-400 text-xs mb-2">GSTIN</p>
              <p className="text-orange-400 font-mono text-sm" data-testid="footer-gst">
                09EALPG7629N1ZW
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm" data-testid="copyright">
              © {new Date().getFullYear()} Punjabi Chaska. All Rights Reserved.
            </p>
            <div className="flex items-center gap-6">
              <span className="text-gray-500 text-sm">Premium Hing Since 2026</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
